import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "",
    user: null,
    type: ""
  },
  getters: {
    getToken: state => {
      if (!state.token && localStorage.getItem("token")) {
        state.token = localStorage.getItem("token");
      }
      return state.token;
    },
    getUser: state => {
      if (!state.user && localStorage.getItem("user")) {
        state.user = JSON.parse(localStorage.getItem("user"));
      }
      return state.user;
    },
    getType: state => {
      if (!state.type && localStorage.getItem("type")) {
        state.type = localStorage.getItem("type");
      }
      return state.type;
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    setUser(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    setType(state, type) {
      state.type = type;
      localStorage.setItem("type", JSON.stringify(type));
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit("setToken", token);
    },
    setUser({ commit }, user) {
      commit("setUser", user);
    },
    setType({ commit }, type) {
      commit("setType", type);
    }
  },
  modules: {}
});
